<template>
  <div>
    카테고리
  </div>
</template>

<script>
export default {
  data() {
    return {
      html: ''
    }
  },
  mounted() {
    this.$eventHub.$emit('content-loaded')
  }
}
</script>
